<template>
    <my-form table>
        <el-form-item label="推送状态" class="table-full-row">
            <span v-if="ggstatus=='0'">已推送至公共服务平台，等待校验</span>
            <span v-if="ggstatus=='1'">已推送至公共服务平台</span>
            <span v-if="ggstatus=='2'">公共服务平台正在校验：校验结果:{{ggyj}}</span>
            <span v-if="ggstatus=='-1'">尚未推送至公共服务平台</span>
            <span v-if="ggstatus=='3'">公告已被退回:{{ggyj}}</span>
            <span v-if="ggstatus=='8'">待河北省交通招投标网人员审核</span>
            <span v-if="ggstatus=='9'">公告已发布</span>
        </el-form-item>
        <el-form-item label="推送单位" class="table-full-row">
            <div v-for="(item,index) in shdwlist">
                {{item.xtname}}:{{item.dwname}}
            </div>
        </el-form-item>
        <el-form-item label="其他审核流程" class="table-full-row" v-if="ggprocess.hasother&&ggprocess.otherlist.length>0">
            <div v-for="item in ggprocess.otherlist">
                {{item.auditdw}}:{{item.auditstatus}}
            </div>
        </el-form-item>
        <el-form-item label="住建审核流程" class="table-full-row" v-if="ggprocess.haszj&&ggprocess.zjlist.length>0">
            <div v-for="item in zjprocesslist">
                {{item.node}}:
                <span v-for="x in item.nodelist">
                    {{x.auditdw}}--{{x.audituser}}--{{x.auditstatus}};
                </span>
            </div>
        </el-form-item>
        <template slot="btn" class="btn">
            <el-button icon="el-icon-circle-check" type="primary" @click="funSend()">
                确定
            </el-button>
        </template>
    </my-form>

</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";

export default {
    mixins: [FORM_PAGE_MIXIN],
    props: {
        row: {
            type: Object,
        },
    },
    data() {
        var that = this;
        return {
            ggstatus:'',
            ggyj:'',
            ggprocess:[],
            shdwlist:[],
            zjprocesslist:[],
        };
    },
    methods: {
        funSend(){
            this.$emit('cancle');
        },
 
    },
    mounted() {
        var that = this
        // 获取审核单位列表
        that.$get(`${this.getGetters('mngUrl')}/manage/business/AuditZbgg/getshdw.json`, {
            ggcode:that.row.ggcode
        }, (data, res) => {
            that.shdwlist = data
        });
        // 获取状态
        that.$get(`${this.getGetters('mngUrl')}/manage/business/AuditZbgg/getTbzt.json`, {
            ggcode:that.row.ggcode
        }, (data, res) => {
            that.ggstatus = data.bj
            that.ggprocess = data.shdw
            that.ggyj = data.yj
            that.zjprocesslist = data.zjprocesslist
        });
        
    }
};
</script>

<style lang="scss" scoped>
</style>